import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        // Get language from localStorage or default to Croatian
        const savedLanguage = localStorage.getItem('historioLanguage');
        return savedLanguage || 'hr';
    });

    useEffect(() => {
        // Save language to localStorage whenever it changes
        localStorage.setItem('historioLanguage', language);
    }, [language]);

    const toggleLanguage = () => {
        setLanguage(prev => prev === 'hr' ? 'en' : 'hr');
    };

    const value = {
        language,
        setLanguage,
        toggleLanguage,
        isCroatian: language === 'hr',
        isEnglish: language === 'en'
    };

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};
